import * as React from "react";

/**
 * Surface container (DS card): white, 12px corners, lavender hairline, shadow xs at rest; interactive cards lift 2px. accent is the purple "Up next" hero; now is the butter attention card.
 */
export interface CardProps extends Omit<React.HTMLAttributes<HTMLElement>, "title"> {
  as?: keyof JSX.IntrinsicElements;
  tone?: "default" | "sunken" | "accent" | "now";
  /** sm r18 p14/16 · md r20 p18/20 · lg r22 p22/24 · flush (no padding, clips media) */
  size?: "sm" | "md" | "lg" | "flush";
  interactive?: boolean;
  /** Card title (Hind Bold 16) */
  title?: React.ReactNode;
  /** Right side of the header, e.g. a "See all" link */
  action?: React.ReactNode;
  children?: React.ReactNode;
}

export function Card({
  as = "div",
  tone = "default",
  size = "md",
  interactive,
  title,
  action,
  className,
  children,
  ...rest
}: CardProps): JSX.Element {
  const Tag = as as React.ElementType;
  const cls = [
    "gk-card",
    tone !== "default" && "gk-card--" + tone,
    size !== "md" && "gk-card--" + size,
    interactive && "gk-card--interactive",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <Tag className={cls} {...rest}>
      {(title || action) && (
        <div className="gk-card__head">
          {title && <h3 className="gk-card__title">{title}</h3>}
          {action}
        </div>
      )}
      {children}
    </Tag>
  );
}
